import { useNavigate } from 'react-router-dom'

import {
  ConnectWalletDialog,
  DividedContainer,
  Loader,
  LoaderColorE,
  ImagePreviewContainer,
} from 'primsell-shared-layer/components'
import { BurnForm, BurnFormInfo } from 'components'

import { useRedeemCampaignController } from './redeem-campaign.controller'

import routes from 'router/routes'

import * as S from './redeem-campaign.styles'

const RedeemCampaign = () => {
  const navigate = useNavigate()
  const {
    isConnectButtonDisabled,
    formikExternalRef,
    isLoadingCampaignPublic,
    campaignPublicDetails,
    mediumPublicCampaignImage,
    originalPublicCampaignImage,
    isOpenConnectDialog,
    setIsOpenConnectDialog,
    handleSubmitBurnForm,
    handleDisconnect,
  } = useRedeemCampaignController()

  if (!campaignPublicDetails) {
    if (isLoadingCampaignPublic) {
      return <Loader color={LoaderColorE.DARK} />
    } else navigate(routes.ROUTE_NOT_FOUND)
  }

  return (
    <>
      <DividedContainer
        left={
          <S.NFTDetailsContainer>
            <ImagePreviewContainer previewSrc={mediumPublicCampaignImage} modalSrc={originalPublicCampaignImage} />
            <S.NFTTitle variant="h3">{campaignPublicDetails?.name}</S.NFTTitle>
          </S.NFTDetailsContainer>
        }
        right={
          <S.BurnFormContainer>
            <BurnFormInfo
              title="Burn NFT"
              isConnectButtonDisabled={isConnectButtonDisabled}
              onWalletConnect={() => setIsOpenConnectDialog(true)}
              onWalletDisconnect={handleDisconnect}
            />
            <BurnForm formikRef={formikExternalRef} handleSubmit={handleSubmitBurnForm} actionText="Burn NFT" />
          </S.BurnFormContainer>
        }
      />
      <ConnectWalletDialog open={isOpenConnectDialog} handleClose={() => setIsOpenConnectDialog(false)} />
    </>
  )
}

export { RedeemCampaign }
